import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
// Contexto
// import dataContext from "../context/User";

// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from '../componentes/Footer';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
import BarChart from "../element/charts/BarChart";

import "../css/styleAdmin.css";

const Stadistica = () => {
  const history = useHistory();

  // const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  datos = JSON.parse(datos);

  if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1 ) {
      history.push("/");
    }
  }  

  const [total, setTotal] = useState(0);
  const [totalConsulta, setTotalConsulta] = useState();
  const [last, setLast] = useState();
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    const fechaActual = (i = 0) => {
      let fecha = new Date(Date.now());
  
      let dd = fecha.getDate() + i;
      let mm = fecha.getMonth() + 1;
      let yyyy = fecha.getFullYear();
  
      if (mm < 10) {
          mm = "0" + mm;
      }
  
      if (dd < 10) {
          dd = "0" + dd;
      }
      return yyyy + "-" + mm + "-" + dd;
  }
    let start = fechaActual();
    let end  = fechaActual();

    setDateStart(start);
    setDateEnd(end);
    
    Promise.all([
      GetFetch.statisTotal(start,end, datos.token).then((datoss) => {
        setTotal(datoss.result[0].consulta);
      }),
      GetFetch.statisTotalConsulta(start,end, datos.token).then((datoss) => {
        setTotalConsulta(datoss.result);
      }),
      GetFetch.statisLast(start,end, datos.token).then((datoss) => {
        setLast(datoss.result);
      }),
    ]).then(() => setCargando(false)).catch(() => setCargando(false))
    loadMenu();
  }, [datos.token]);

  const dataStartSet = (e)=>{
    setDateStart(e.target.value);
  }

  const dataEndSet = (e)=>{
    setDateEnd(e.target.value);
  }

  const btnStatic = ()=>{
    Promise.all([
      GetFetch.statisTotal(dateStart,dateEnd, datos.token).then((datoss) => {
        setTotal(datoss.result[0].consulta);
      }),
      GetFetch.statisTotalConsulta(dateStart,dateEnd, datos.token).then((datoss) => {
        setTotalConsulta(datoss.result);
      }),
      GetFetch.statisLast(dateStart,dateEnd, datos.token).then((datoss) => {
        setLast(datoss.result);
      }),
    ])
  }

  const listaConsultas = totalConsulta && totalConsulta.length > 0 ? totalConsulta : [];
  const listaDetalle = last && last.length > 0 ? last : [];

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Estadística de uso</h2>

        <div className="card">
          <div className="card-body">
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="startDate">Desde</label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  name="startDate"
                  onChange={dataStartSet}
                  value={dateStart}
                />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="endDate">Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  name="endDate"
                  onChange={dataEndSet}
                  value={dateEnd}
                />
              </div>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={btnStatic}
            >
              <i className="fa fa-search mr-2" aria-hidden="true"></i>
              Consultar
            </button>
          </div>
        </div>

        {cargando ? (
          <SkeletonCard rows={5} />
        ) : (
          <>
            <div className="esen-stat-grid">
              <div className="esen-stat esen-stat--hero">
                <div>
                  <div className="esen-stat-value">{total}</div>
                  <div className="esen-stat-label">
                    Consultas del {dateStart} al {dateEnd}
                  </div>
                </div>
              </div>
              {listaConsultas.length > 0 ? (
                <div className="esen-stat">
                  <div>
                    <div className="esen-stat-value">{listaConsultas.length}</div>
                    <div className="esen-stat-label">Tipos de consulta</div>
                  </div>
                </div>
              ) : null}
            </div>

            {listaConsultas.length > 0 ? (
              <>
                <div className="card">
                  <div className="card-header">
                    <i className="fa fa-bar-chart mr-2" aria-hidden="true"></i>
                    Consultas por tipo
                  </div>
                  <div className="card-body">
                    <BarChart
                      data={listaConsultas.map((elemtto) => ({
                        label: elemtto._id,
                        value: elemtto.count,
                      }))}
                      height={180}
                    />
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">Consulta</th>
                            <th scope="col" className="text-right">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listaConsultas.map((elemtto, key) => (
                            <tr key={key}>
                              <td>{elemtto._id}</td>
                              <td className="text-right">{elemtto.count}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <EmptyState icon="fa-bar-chart" title="Aún no hay consultas">
                No se registraron consultas en el rango de fechas seleccionado.
              </EmptyState>
            )}

            {listaDetalle.length > 0 ? (
              <div className="card">
                <div className="card-header">
                  <i className="fa fa-list mr-2" aria-hidden="true"></i>
                  Detalle de consultas
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">Fecha</th>
                          <th scope="col">Alumno</th>
                          <th scope="col">Consulta</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listaDetalle.map((elemtto, key) => (
                          <tr key={key}>
                            <td>{elemtto.creado}</td>
                            <td>{elemtto.alumno}</td>
                            <td>{elemtto.consulta}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default Stadistica;
